<template>
  <div class="wrapper-page animated fadeInDown">
    <div class="panel panel-color panel-primary">
      <div class="panel-heading">
        <h3 class="text-center m-t-10"><strong>Login</strong></h3>
      </div>

      <form
        class="form-horizontal m-t-40"
        method="POST"
        @submit.prevent="login"
      >
        <div
          v-if="$store.state.alert != null"
          class="alert animated bounceInDown"
          :class="'alert-' + $store.state.alert.status || ''"
          role="alert"
        >
          <span v-html="$store.state.alert.message"></span>
          <button
            type="button"
            class="close"
            v-if="$store.state.alert.dismissable || true"
            @click="$store.commit('showAlert', null)"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="form-group" :class="{ 'has-error': errors.email }">
          <div class="col-xs-12">
            <input
              class="form-control"
              type="email"
              placeholder="Email Address"
              v-model="email"
              required
              name="email"
              autofocus
            />
            <span class="help-block" role="alert" v-if="errors.email">
              <strong>{{ errors.email[0] }}</strong>
            </span>
          </div>
        </div>

        <div class="form-group" :class="{ 'has-error': errors.password }">
          <div class="col-xs-12">
            <input
              class="form-control"
              type="password"
              v-model="password"
              placeholder="Password"
              required
              name="password"
            />
            <span class="help-block" role="alert" v-if="errors.password">
              <strong>{{ errors.password[0] }}</strong>
            </span>
          </div>
        </div>

        <div class="form-group">
          <div class="col-xs-12">
            <label class="cr-styled">
              <input type="checkbox" name="remember" v-model="remember" />
              <i class="fa"></i>
              Remember me
            </label>
          </div>
        </div>

        <div class="form-group text-right">
          <div class="col-xs-12">
            <button class="btn btn-purple w-md" type="submit">Login</button>
          </div>
        </div>

        <div class="form-group m-t-30">
          <div class="col-sm-7">
            <a href="/password/reset"
              ><i class="fa fa-lock m-r-5"></i> Forgot your password?</a
            >
          </div>
          <div class="col-sm-5 text-right">
            <a href="/register">Create an account</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",

  data() {
    return {
      email: "",
      password: "",
      remember: false,
      errors: []
    };
  },

  methods: {
    login() {
      this.$store
        .dispatch("auth/login", {
          email: this.email,
          password: this.password,
          remember: this.remember
        })
        .then(() => {
          window.location.href = "/dashboard";
        })
        .catch(({ response }) => {
          this.errors = response.data.errors || [];
        });
    }
  }
};
</script>
